<template>
  <detail
    :on-manager="onManager"
    :data="data"
    :isEditDesc="false"
    :isEditName="false"
    :base-info="baseInfo" />
</template>

<script>
import {
  getEnabledTableColumn,
} from '@/utils/common/tableColumn'
import {
  getSettingTableColumn,
  getPeriodTableColumn,
  getTypeTableColumn,
  getTimeFromTableColumn,
} from '../utils/columns'

export default {
  name: 'SuggestsRuleDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        // {
        //   field: 'type',
        //   title: this.$t('scope.text_827'),
        //   minWidth: 70,
        //   showOverflow: 'title',
        //   formatter: ({ row, cellValue }) => {
        //     if (!cellValue) {
        //       return '-'
        //     }
        //     return this.$t('suggestsyRuleTypes')[cellValue]
        //   },
        // },
        getEnabledTableColumn(),
        getSettingTableColumn(),
        getPeriodTableColumn(),
        getTimeFromTableColumn(),
        {
          field: 'exec_time',
          title: this.$t('bill.text_218'),
          minWidth: 70,
          showOverflow: 'title',
          formatter: ({ row, cellValue }) => {
            if (!cellValue) {
              return '-'
            }
            return this.$moment(cellValue).format()
          },
        },
        getTypeTableColumn(),
      ],
    }
  },
}
</script>
